import { colors } from "../defines";
import { getColorVariable } from "../getColorVariable";

/**
 * Resolves a color value for components that support color props.
 * This function provides consistent color handling across Text and Heading components.
 *
 * @param {string} color - The color value to resolve
 * @returns {string|undefined} - The resolved color value or undefined if no color provided
 *
 * Resolution order:
 * 1. Direct color values (hex, rgb, hsl, css variables) are returned as-is
 * 2. Semantic color names are looked up in the colors object
 * 3. Base semantic names (e.g., "primary") are tried with "-500" suffix
 * 4. Fallback to getColorVariable for CSS variable conversion
 */
export const getComponentColor = (color) => {
  let result = undefined;

  if (color) {
    result = colors[color] ?? colors[`${color}-500`] ?? getColorVariable(color);
  }

  return result;
};
